import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, Transition as _Transition, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { watch, unref } from 'vue';
import { useRouter } from 'vue-router';
import { useGtag } from 'vue-gtag-next';
import { useSharedTheme } from '@/composables';
import { useMeta, useActiveMeta } from 'vue-meta';
import { Navbar, AppFooter, BackToTop } from '@/components';


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const router = useRouter();
const { pageview } = useGtag();
const activeMeta = useActiveMeta();
const { themeCls } = useSharedTheme();

useMeta({
  charset: 'utf8',
  og: {
    locale: 'id_ID',
    type: 'website',
    site_name: 'MediaSolusiSukses'
  },
  htmlAttrs: {
    amp: true,
    lang: ['en']
  }
});

function trackPageView() {
  setTimeout(() => {
    const { currentRoute, getRoutes } = router;
    const { path } = unref(currentRoute);
    const isValidPath = getRoutes().some((x) => x.path === path);
    if (isValidPath) {
      pageview(path);
    }
  }, 10);
}

watch(
  () => activeMeta,
  () => trackPageView(),
  { deep: true }
);

watch(themeCls, (value) => {
  document.body.className = value;
});

return (_ctx: any,_cache: any) => {
  const _component_metainfo = _resolveComponent("metainfo")!
  const _component_RouterView = _resolveComponent("RouterView")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_metainfo, null, {
      title: _withCtx(({ content }) => [
        _createTextVNode(_toDisplayString(`Media Solusi Sukses | ${content}`), 1)
      ]),
      _: 1
    }),
    _createVNode(_unref(Navbar)),
    _createVNode(_component_RouterView, null, {
      default: _withCtx(({ Component, route }) => [
        _createVNode(_Transition, {
          mode: "out-in",
          name: (route.meta.transition as string)
        }, {
          default: _withCtx(() => [
            (_openBlock(), _createBlock(_resolveDynamicComponent(Component)))
          ]),
          _: 2
        }, 1032, ["name"])
      ]),
      _: 1
    }),
    _createVNode(_unref(BackToTop)),
    _createVNode(_unref(AppFooter))
  ], 64))
}
}

})